import React, { FC, memo, useEffect, useState } from 'react'

import { useSetFocus } from '@please/lrud'

import { Button } from '@/components/Button/Button' // Adjust the import path as necessary
import { orientation } from '@/constants/focus'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { ButtonBox } from './styles'

interface ButtonBoxComponentProps {
  hasFeatureButton: boolean
  featureButtonTitle: string
  linkingButtonHandler: () => void
  continueButtonHandler: () => void
}

const focusId = 'ButtonBoxComponent'

const ButtonBoxComponentRaw: FC<ButtonBoxComponentProps> = ({
  hasFeatureButton,
  featureButtonTitle,
  linkingButtonHandler,
  continueButtonHandler,
}) => {
  const setFocus = useSetFocus()
  const { t } = useCommonTranslation()
  const BUTTON_WIDTH = 370

  const [defaultFocusChild, setDefaultFocusChild] = useState(0)

  useEffect(() => {
    setFocus(focusId)
  }, [])

  const onMove = (e: MoveEvent) => {
    const currentChildIndex =
      e.direction === 'forward'
        ? Number(e.prevChildIndex) + 1
        : Number(e.prevChildIndex) - 1
    setDefaultFocusChild(currentChildIndex)
  }

  return (
    <ButtonBox
      focusId={focusId}
      defaultFocusChild={defaultFocusChild}
      orientation={orientation.HORIZONTAL}
      onMove={onMove}
    >
      {hasFeatureButton && (
        <Button
          text={featureButtonTitle}
          onClick={linkingButtonHandler}
          width={BUTTON_WIDTH}
        />
      )}
      <Button
        text={t('featureScreen.continueToSportWorld')}
        onClick={continueButtonHandler}
        width={BUTTON_WIDTH}
      />
    </ButtonBox>
  )
}

export const ButtonBoxComponent = memo(ButtonBoxComponentRaw)
